import { useState,useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { ButtonBasic, SelectEmpresas, SelectInsertEmail, SelectUser } from '../../components';
import GrupoService from '../../services/grupo.service';

const ModalGrupos = ({show, hideModal, item, onGuardar, type}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [emails, setEmails] = useState(item?.emailArr_g || []);

    const [formAll, setFormAll] = useState({
        nombre_g: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        personal: {
            texto: [],
            textoErr: 'Las acciones son requeridas',
            estadoErr: false,
            tipo: 'string'
        },
        empresaId_g: {
            texto: null,
            textoErr: 'El personal es requerido',
            estadoErr: false,
            tipo: 'string'
        }
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if(!value || value === ''){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {emails};
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['nombre_g','personal','empresaId_g']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_g > 0) {
                form.id_g = item.id_g
                GrupoService.update(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }else{
                GrupoService.register(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.nombre_g,'nombre_g')
                onChangeForm(item?.empresaId_g,'empresaId_g')
                if(item?.idpersonal?.length > 0){
                    onChangeForm(item.idpersonal?.map(ur=>ur),'personal')
                }
                if(item.emailArr_g?.length > 0){
                    setEmails(item.emailArr_g)
                }
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: isDarkMode ? '#e0e0e0' : '#000',
                borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#3d4a62' : 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 45,
        }
    }), [isDarkMode]);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_g > 0 ? 'Editar Grupo' : 'Registrar Grupo'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Nombre</Typography>
                            <TextField
                                fullWidth
                                value={formAll.nombre_g.texto}
                                autoComplete='off'
                                error={formAll.nombre_g.estadoErr}
                                helperText={formAll.nombre_g.estadoErr && formAll.nombre_g.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'nombre_g')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Empresa</Typography>
                            <SelectEmpresas
                                value={formAll.empresaId_g.texto}
                                onChange={(opt) => onChangeForm(opt?.value,'empresaId_g')}
                            />
                            {formAll.empresaId_g.estadoErr && (
                                <Typography sx={{color: isDarkMode ? '#f87171' : 'red',fontSize:11,marginLeft:1}}>{formAll.empresaId_g.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Integrantes</Typography>
                            <SelectUser
                                value={formAll.personal.texto}
                                filter='allActive'
                                onChange={(opt) => onChangeForm(opt.map(op=>(op.value)),'personal')}
                                isMulti
                            />
                            {formAll.personal.estadoErr && (
                                <Typography sx={{color: isDarkMode ? '#f87171' : 'red',fontSize:11,marginLeft:1}}>{formAll.personal.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Emails</Typography>
                            <SelectInsertEmail
                                id="selectEmails"
                                value={emails}
                                onChange={setEmails}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                        isDisabled={formAll?.emails?.texto?.length === 0 || formAll?.personal?.texto?.length === 0}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalGrupos